import {inject, Injectable} from '@angular/core';
import {CustomerModalApiService} from "./customer-modal-api.service";
import {
  AttachData,
  BaseCustomerProps,
  CustomerData,
  CustomerDataInTable
} from "../types/customer-modal.types";
import {RecordTableApiService} from "../../../../services-api/record-table-api.service";
import {
  RecordData,
  RecordsDataRequestQueryParams,
  RecordUpdateRequestParams
} from "../../../../types/records-table.types";
import {BaseModalApiService} from "../../services/base-modal-api.service";
import {GetRecordPropertyDataByIdParams} from "../../base-modal/types/base-modal.types";
import {Pageable} from "../../../../types/pagable.types";

@Injectable({
  providedIn: 'root'
})
export class CustomerModalService {
  private customerModalApiService: CustomerModalApiService = inject(CustomerModalApiService);
  private recordsTableApiService: RecordTableApiService = inject(RecordTableApiService);
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);

  public fetchCustomerData(params: GetRecordPropertyDataByIdParams): Promise<CustomerData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.fetchDataById<CustomerData>(params).subscribe({
        next: (customer) => resolve(customer),
        error: (error) => reject(error)
      });
    });
  }

  public fetchCustomersData(path: string, queryParams: RecordsDataRequestQueryParams): Promise<Pageable<RecordData>> {
    return new Promise((resolve, reject) => {
      this.recordsTableApiService.fetchRecordTableData(path, queryParams).subscribe({
        next: (recordsTableData: Pageable<RecordData>) => resolve(recordsTableData),
        error: (error) => reject(error)
      });
    });
  }

  public createCustomer(baseCustomerProps: BaseCustomerProps, feedbackId: number): Promise<CustomerData> {
    return new Promise((resolve, reject) => {
      this.customerModalApiService.createCustomer(baseCustomerProps, feedbackId).subscribe({
        next: (customer) => resolve(customer),
        error: (error) => reject(error)
      });
    });
  }

  public updateCustomer(params: RecordUpdateRequestParams): Promise<CustomerData> {
    return new Promise((resolve, reject) => {
      this.recordsTableApiService.updateRecord<CustomerData>(params).subscribe({
        next: (customer) => resolve(customer),
        error: (error) => reject(error)
      });
    });
  }

  public attachCustomer(attachData: AttachData): Promise<void> {
    return new Promise((resolve, reject) => {
      this.customerModalApiService.attachCustomer(attachData).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public detachCustomer(feedbackId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.customerModalApiService.detachCustomer(feedbackId).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public updateCustomerDataInTable(customerId: number | null): CustomerDataInTable {
    return {
      id: customerId,
      isValid: !!customerId
    };
  }
}
